import { OnboardingFormFields } from '@Types/index';
import { ErrorType } from '@Services/errors/errorType.ts';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import type { IErrorHandling } from '@Types/index';

export const EmailErrorMap = {
  EMAIL_ALREADY_EXISTS: { errorCode: 4041, errorType: ErrorType.BUSINESS_LOGIC },
  INVALID_EMAIL_FORMAT: { errorCode: 4024, errorType: ErrorType.BUSINESS_LOGIC },
  AUTHORIZED_USER_EMAIL_ALREADY_EXISTS: { errorCode: 90225, errorType: ErrorType.BUSINESS_LOGIC },
  EMAIL_CHANGE_IS_NOT_ALLOWED: { errorCode: 41195, errorType: ErrorType.BUSINESS_LOGIC },
  UBO_EMAIL_ALREADY_EXISTS: { errorCode: 41196, errorType: ErrorType.BUSINESS_LOGIC },
  EMAIL_ALREADY_EXISTS_AS_AUTHORIZED_USER: {
    errorCode: 50729,
    errorType: ErrorType.BUSINESS_LOGIC,
  },
};

export const getEmailErrorsObjectMap = (): Map<number, IErrorHandling> => {
  return new Map<number, IErrorHandling>([
    [
      EmailErrorMap.EMAIL_ALREADY_EXISTS.errorCode,
      {
        errorCode: EmailErrorMap.EMAIL_ALREADY_EXISTS.errorCode,
        redirectPath: routesModel[RoutesMap.ONE_OF_US].path,
        relatedFieldName: OnboardingFormFields.EMAIL,
      },
    ],
    [
      EmailErrorMap.INVALID_EMAIL_FORMAT.errorCode,
      {
        errorCode: EmailErrorMap.INVALID_EMAIL_FORMAT.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.EMAIL,
        callBack: () => {},
      },
    ],
    [
      EmailErrorMap.AUTHORIZED_USER_EMAIL_ALREADY_EXISTS.errorCode,
      {
        errorCode: EmailErrorMap.AUTHORIZED_USER_EMAIL_ALREADY_EXISTS.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.EMAIL,
        callBack: () => {},
      },
    ],
    [
      EmailErrorMap.EMAIL_CHANGE_IS_NOT_ALLOWED.errorCode,
      {
        errorCode: EmailErrorMap.EMAIL_CHANGE_IS_NOT_ALLOWED.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.EMAIL,
        callBack: () => {},
      },
    ],
    [
      EmailErrorMap.UBO_EMAIL_ALREADY_EXISTS.errorCode,
      {
        errorCode: EmailErrorMap.UBO_EMAIL_ALREADY_EXISTS.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.EMAIL,
        callBack: () => {},
      },
    ],
    [
      EmailErrorMap.EMAIL_ALREADY_EXISTS_AS_AUTHORIZED_USER.errorCode,
      {
        errorCode: EmailErrorMap.EMAIL_ALREADY_EXISTS_AS_AUTHORIZED_USER.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.EMAIL,
        callBack: () => {},
      },
    ],
  ]);
};
